import React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '_src/modules';

const container = document.getElementById('app');
const root = createRoot(container);
root.render(<App />);
